import './ride-metric.css';
import { useRef } from 'react';
import { useStatisticFit } from './use-statistic-fit';

interface RideMetricProperties {
  readonly label: string;
  readonly liveValue: string;
  readonly value: string;
  readonly unit?: string;
  readonly totalLabel?: string;
  readonly smallerFraction?: boolean;
}

/** Keeps statistic values, units, and ride totals readable at each composition size. */
export function RideMetric({ label, liveValue, value, unit, totalLabel = 'of', smallerFraction = false }: RideMetricProperties) {
  const reading = useRef<HTMLElement>(null);
  useStatisticFit(reading, .3);
  const decimalIndex = smallerFraction ? liveValue.indexOf('.') : -1;
  return <div className={`metric${unit ? '' : ' metric-time'}`}>
    <span className="metric-label">{label}</span>
    <strong ref={reading} aria-live="off" className={smallerFraction ? 'metric-value-decimal' : undefined}><span className="statistic-reading">
      {decimalIndex < 0 ? liveValue : <>{liveValue.slice(0, decimalIndex + 1)}<span className="metric-fraction">{liveValue.slice(decimalIndex + 1)}</span></>}
      {unit && <span className="metric-unit"> {unit}</span>}
    </span></strong>
    <small>{totalLabel} {value}{unit && ` ${unit}`}</small>
  </div>;
}
